import { useEffect } from "react";

import {
    useExperimentExposure,
    experiments
} from "@/utils/experiment/index.ts";

import {
    UniformEntryPage,
    UniformEntryPageProps
} from "./uniform-entry-page.tsx";

export const UniformJiraPricingEntryPage = (props: UniformEntryPageProps) => {
    const [hasFired, fireExposure] = useExperimentExposure(
        experiments.jiraPricingPageWaeMigration
    );
    useEffect(() => {
        if (!hasFired) {
            fireExposure();
        }
    }, [hasFired, fireExposure]);

    return <UniformEntryPage {...props} />;
};
